module.exports = __webpack_public_path__ + "img/dongji_ps_10.a8d9963e.jpg";